// extracted by mini-css-extract-plugin
module.exports = {"description":"folder-state_description__1OB3_","warning":"folder-state_warning__mKi9t","text":"folder-state_text__1nrQW"};